import {
    ROUTEUSER_FETCHING,
    ROUTEUSER_FAILED,
    ROUTEUSER_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case ROUTEUSER_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };    
        case ROUTEUSER_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case ROUTEUSER_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false};
        default:
            return state;
    }
}